import { useDispatch } from 'react-redux'
import { useCallback, useEffect } from 'react'
import { useI18n } from 'builder/hooks/useI18n'
import { actions, selectors } from 'builder/modules/resumeDistribution'
import { useTypedSelector } from 'builder/hooks/useTypedSelector'
import { useMediaQueries } from 'builder/hooks/useMediaQueries'
import {
  Container,
  TitleContainer,
  Title,
  CountContainer,
  CountText,
  TooltipWrapper,
  TooltipQuestionWrapper,
} from './styles'
import { ComposeParams, JobPreferencesBannerProps } from './types'
const TRANSLATION = 'builder.resume_distribution.landing.job_preferences_form.banner'

export const RecruiterCountBanner = ({ data, isRDVersion2 = false }: JobPreferencesBannerProps) => {
  const { i18n } = useI18n()
  const dispatch = useDispatch()
  const { isPhone } = useMediaQueries()
  const count = useTypedSelector(selectors.recruitersCount)

  const composeParams = useCallback((): ComposeParams => {
    const { industry, state } = data

    const params: ComposeParams = {}
    if (state?.id) params.stateId = state?.id
    if (industry) params.industryId = industry

    return params
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.state?.id, data.industry])

  useEffect(() => {
    const params = composeParams()
    dispatch(actions.fetchRecruitersCount(params))
  }, [composeParams, data.industry, data.remote, data.state, dispatch])

  return (
    <Container isRDVersion2={isRDVersion2}>
      <TitleContainer>
        <Title>{i18n.t(`${TRANSLATION}.header`)}</Title>
      </TitleContainer>
      <CountContainer>
        <CountText>{count}</CountText>
        <TooltipWrapper>
          <TooltipQuestionWrapper
            textAlign="left"
            align={isPhone ? 'unset' : 'center'}
            position={isPhone ? 'left' : 'top'}
            multiline
          >
            {i18n.t(`${TRANSLATION}.tooltip`)}
          </TooltipQuestionWrapper>
        </TooltipWrapper>
      </CountContainer>
    </Container>
  )
}
